<template>
  <div class="d-flex align-items-center gap-2">
    <snow-button
      size="sm"
      icon="ph-bold ph-squares-four"
      :variant="preferences.product_list === 'gallery' ? 'gray' : 'borderless'"
      @click="change('gallery')"
    />
    <snow-button
      size="sm"
      icon="ph-bold ph-list-dashes"
      :variant="preferences.product_list === 'list' ? 'gray' : 'borderless'"
      @click="change('list')"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("user", ["preferences"])
  },
  methods: {
    change(v) {
      this.$store.commit("user/setPreferences", { product_list: v });
      localStorage.setItem("productsDisplay", v);
    }
  }
};
</script>
